import apiHeader from '@/helpers/apiHeader';

const mcrAttachmentService = {
  getAttachments(mcrCode) {
    return apiHeader.get(`request-pool/emcr-attachment/${mcrCode}`);
  },
  uploadAttachment(mcrCode, file, onUploadProgress) {
    const fd = new FormData();
    fd.append('file', file);
    return apiHeader.post(`request-pool/emcr-attachment/${mcrCode}`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      ...(onUploadProgress ? { onUploadProgress } : {}),
    });
  },
  deleteAttachment(id) {
    return apiHeader.delete(`request-pool/emcr-attachment/${id}`);
  },
};

export default mcrAttachmentService;
